import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '../ui/badge';
import { AlertCircle, CheckCircle, AlertTriangle } from 'lucide-react';

// Labels match IRAC Classification Rule names (initialize-defaults) plus legacy
// "Regular" / "Substandard" / "NPA" retained for pre-reclassification rows.
const riskConfig = {
  Standard: { className: 'risk-current', icon: CheckCircle, label: 'Current' },
  Regular: { className: 'risk-current', icon: CheckCircle, label: 'Current' },
  'SMA-0': { className: 'risk-sma0', icon: AlertTriangle, label: '1-30 DPD' },
  'SMA-1': { className: 'risk-sma1', icon: AlertTriangle, label: '31-60 DPD' },
  'SMA-2': { className: 'risk-sma2', icon: AlertCircle, label: '61-90 DPD' },
  'Sub-Standard': { className: 'risk-npa', icon: AlertCircle, label: 'Sub-Standard' },
  Substandard: { className: 'risk-npa', icon: AlertCircle, label: 'Substandard' },
  NPA: { className: 'risk-npa', icon: AlertCircle, label: 'NPA' },
  Doubtful: { className: 'risk-npa', icon: AlertCircle, label: 'Doubtful' },
  Loss: { className: 'risk-npa', icon: AlertCircle, label: 'Loss' },
};

export function RiskBadge({ status }) {
  const config = riskConfig[status] || {
    className: 'risk-current',
    icon: CheckCircle,
    label: status || 'Current',
  };
  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={`${config.className} gap-1`}
      data-testid="risk-badge"
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}

RiskBadge.propTypes = {
  status: PropTypes.string.isRequired,
};
